import { Component, OnInit, Inject, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {DominiosService, UsuarioService, ContaCreditoService } from '../shared/services/acordo-ressarcimento/api/services';

import { AppComponent } from '../app.component';
import { ContaCredito } from '../shared/services/acordo-ressarcimento/api/models';
import { Observable, of } from 'rxjs';
import { LoadingService } from '../shared/services/components/loading.service';

@Component({
  selector: 'app-dominio-conta-bancaria',
  templateUrl: './dominio-conta-bancaria.component.html',
  styleUrls: ['./dominio-conta-bancaria.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DominioContaBancariaComponent implements OnInit {
  private _submittedNovoDevedor = false;
  public formContaBancaria: FormGroup;
  public contasBancaria: ContaCredito[];
  public contaBancaria: ContaCredito;
  public loadingLista = false;
  public edicaoContaBancaria = false;
  public indexEdicaoContaBancaria = undefined;  

  source = [];
  columnsTemplate = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public dominiosService: DominiosService,
    public contaBancariaService: ContaCreditoService,
    private route: ActivatedRoute,

    public usuarioService: UsuarioService,
    private loading: LoadingService,
    @Inject(AppComponent) public appComponent: AppComponent) {

    
  }

  public ngOnInit() {

    this.obterListaContaBancaria();
    this.inicializarDadosContaBancaria();
    this.criarFormulario(this.contaBancaria);
  }

  private obterListaContaBancaria() {

    this.contaBancariaService.obterContasCreditoResponse(  ).subscribe(result => {
      this.contasBancaria = result.body;
      console.log(JSON.stringify(result.body));
    });

  }
  public openEditarContaBancaria(indexContaBancaria) {
    this.limparDadosContaBancaria();
    this.edicaoContaBancaria = true;
    this.indexEdicaoContaBancaria = indexContaBancaria;
                
    
    this.formContaBancaria.controls['codigoContaCredito'].setValue(this.contasBancaria[indexContaBancaria].codigoContaCredito);
    this.formContaBancaria.controls['nomeConta'].setValue(this.contasBancaria[indexContaBancaria].nomeConta);    
    this.formContaBancaria.controls['numeroAgencia'].setValue(this.contasBancaria[indexContaBancaria].numeroAgencia);
    this.formContaBancaria.controls['numeroConta'].setValue(this.contasBancaria[indexContaBancaria].numeroConta);
    this.formContaBancaria.controls['numeroDigitoConta'].setValue(this.contasBancaria[indexContaBancaria].numeroDigitoConta);
    this.formContaBancaria.controls['codigoBanco'].setValue(this.contasBancaria[indexContaBancaria].codigoBanco);
  }

  private limparDadosContaBancaria() {
    this.edicaoContaBancaria = false;
    this.formContaBancaria.controls['codigoContaCredito'].setValue(null);
    this.formContaBancaria.controls['nomeConta'].setValue(null);
    this.formContaBancaria.controls['numeroAgencia'].setValue(null);    
    this.formContaBancaria.controls['numeroConta'].setValue(null);    
    this.formContaBancaria.controls['numeroDigitoConta'].setValue(null);    
    this.formContaBancaria.controls['codigoBanco'].setValue(null);    
        

  }

  private inicializarDadosContaBancaria(): void {
    
    this.contaBancaria = {};
    this.contaBancaria.codigoContaCredito = 0;
    this.contaBancaria.nomeConta = "";
    
  }

  private criarFormulario(contaBancaria: ContaCredito) {
    this.formContaBancaria = this.formBuilder.group({
      codigoContaCredito: null,//categoriaDevedor.codigoCategoriaDevedor,
      nomeConta: "",
      numeroAgencia: "",
      numeroConta: "",
      numeroDigitoConta: "",
      codigoBanco: "",
      
    });
  }

  public abrirModalContaBancaria (evento) {
    
    console.log("Abrindo modal de conta bancaria");
  }

  onFecharModalContaBancaria() {
    console.log("Fechando Modal");

  }

  public getSubmittedDevedor() {
    return this._submittedNovoDevedor;
  }

  

  public salvarContaBancaria(modalGravando, modalCategoriaDevedor) {
    
    if (!this.validarFormulario()) {
      return;
    }
    modalCategoriaDevedor.close();
    this.contaBancaria.nomeConta = this.formContaBancaria.value['nomeConta'];
    this.contaBancaria.codigoContaCredito = this.formContaBancaria.value['codigoContaCredito'];    
    this.contaBancaria.numeroAgencia = this.formContaBancaria.value['numeroAgencia'];
    this.contaBancaria.numeroConta = this.formContaBancaria.value['numeroConta'];
    this.contaBancaria.numeroDigitoConta = this.formContaBancaria.value['numeroDigitoConta'];
    this.contaBancaria.codigoBanco = this.formContaBancaria.value['codigoBanco'];
    

    this.loading.open();

    if (this.edicaoContaBancaria) {      
      this.contaBancariaService.alterarContaCredito(this.contaBancaria).subscribe(result => {
        this.appComponent.createAlert("Dados alterados com sucesso", 'success');
        this.loading.close();
        this.loadingLista = false;
        this.obterListaContaBancaria();
      }, error => {
        this.appComponent.createAlert('Não foi possível salvar a conta bancaria', 'error');
        this.loading.close();
        this.loadingLista = false;
      });
    } else {
    this.contaBancaria.pessoa = {codigoPessoa: 2825 , nomeLegalPessoa: 'PORTO SEGURO CIA DE SEGUROS GERAIS'}
    
    this.contaBancariaService.salvarContaCredito(this.contaBancaria).subscribe(result => {
      this.appComponent.createAlert("Dados salvos com sucesso", 'success');
      this.loading.close();
      this.loadingLista = false;
      this.obterListaContaBancaria();
    }, error => {
      this.appComponent.createAlert('Não foi possível salvar a conta bancaria', 'error');
      this.loading.close();
      this.loadingLista = false;
    });
    
   }
  }

  private validarFormulario(): boolean {
    let isCampoFocus = false;
    var isValido = true;

    if ((this.formContaBancaria.get('numeroAgencia').value == 0) || (this.formContaBancaria.get('numeroAgencia').value == undefined) || (this.formContaBancaria.get('numeroAgencia').value == null)) {
      
        isValido = false;
        this.formContaBancaria.controls['numeroAgencia'].setErrors({ 'incorrect': true });        
    }
    
    if ((this.formContaBancaria.get('numeroConta').value == 0) || (this.formContaBancaria.get('numeroConta').value == undefined) || (this.formContaBancaria.get('numeroConta').value == null)) {
      
      isValido = false;
      this.formContaBancaria.controls['numeroConta'].setErrors({ 'incorrect': true });        
    }

    if ((this.formContaBancaria.get('numeroDigitoConta').value == 0) || (this.formContaBancaria.get('numeroDigitoConta').value == undefined) || (this.formContaBancaria.get('numeroDigitoConta').value == null)) {
      
      isValido = false;
      this.formContaBancaria.controls['numeroDigitoConta'].setErrors({ 'incorrect': true });        
    }

    if ((this.formContaBancaria.get('codigoBanco').value == 0) || (this.formContaBancaria.get('codigoBanco').value == undefined) || (this.formContaBancaria.get('codigoBanco').value == null)) {
      
      isValido = false;
      this.formContaBancaria.controls['codigoBanco'].setErrors({ 'incorrect': true });        
    }
    if (!isValido)
    this.appComponent.createAlert('Preencha os dados corretamente', 'error');
    return isValido;
  }
}
